
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 33.01 25.71"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{staticClass:"cls-1",attrs:{"d":"M31.18 0h-22a1.83 1.83 0 100 3.66h22a1.83 1.83 0 100-3.66zM31.18 11h-22a1.84 1.84 0 100 3.67h22a1.84 1.84 0 100-3.67zM31.18 22h-22a1.84 1.84 0 100 3.67h22a1.84 1.84 0 100-3.67zM3.12.55a1.8 1.8 0 00-2-.41 2 2 0 00-1 1 1.54 1.54 0 00-.14.7 1.7 1.7 0 00.55 1.28 1.26 1.26 0 00.58.41 1.54 1.54 0 00.74.15 1.86 1.86 0 001.82-1.85 1.38 1.38 0 000-.7 1.19 1.19 0 00-.55-.58zM3.12 11.55a1.26 1.26 0 00-.58-.41 1.8 1.8 0 00-2 .41 1.32 1.32 0 00-.41.58 1.65 1.65 0 000 .7 1.79 1.79 0 00.55 1.29 1.41 1.41 0 00.59.4 1.69 1.69 0 001.39 0 1.35 1.35 0 00.59-.4 1.73 1.73 0 00.4-1.29 1.38 1.38 0 000-.7 1.23 1.23 0 00-.55-.58zM2.54 22.15a1.8 1.8 0 00-2 .4 1.83 1.83 0 001.31 3.13 1.65 1.65 0 00.7 0 1.32 1.32 0 00.58-.4 1.76 1.76 0 00.56-1.29 1.74 1.74 0 00-.57-1.31 1.24 1.24 0 00-.58-.55z"}})])
          )
        }
      }
    